import { postAddCommentToTicket } from "../../../app/api/ServiceRequestDetails";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ISaveServiceRequestResponse } from "../../../Orchestrator/Types/Interface/IServiceRequest";
import { IAddCommentToTheTicketActionParams } from "../../../Orchestrator/Types/Interface/IServiceRequestDetails";

class AddCommentToTheTicketAction extends BaseAction<IDefaultActionResult, IAddCommentToTheTicketActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            if (this?.params) {
                const response = await postAddCommentToTicket(this.params);
                if (response.answer && response.status === "ok") {
                    const srData: ISaveServiceRequestResponse = response.answer
                    actionResult.status = "success"
                    actionResult.data = srData
                    updateRecoilState("openCommentAtom", false)
                }
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const addCommentToTheTicketAction = new AddCommentToTheTicketAction();